import {companyFeaturesConstants} from '../../constants';
import {useCompanyFeatureAvailable} from './useCompanyFeatureAvailable';

const featureName = companyFeaturesConstants.VENDORS_DISABLED;

/**
 * Checks if the vendors module is disabled for the company (small ICP setup).
 *
 * @returns {boolean} True when the `vendors_disabled` company feature is enabled.
 *
 * @example
 * const isVendorsDisabled = useIsVendorsDisabled();
 */
export const useIsVendorsDisabled = () => {
  return useCompanyFeatureAvailable(featureName);
};
